import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiHttpService } from '../services/api-http.service';
import { Observable } from 'rxjs';
import { setRequired } from '../shared/utils';
import { DataService } from '../services/data.service';
import { DatiAnagraficiComponent } from '../steps/dati-anagrafici/dati-anagrafici.component';

@Component({
  selector: 'app-indirizzo',
  templateUrl: './indirizzo.component.html',
  styleUrls: ['./indirizzo.component.scss']
})
export class IndirizzoComponent implements OnInit {

  setRequired = setRequired;

  @Input() indirizzoForm!: FormGroup;
  //  = new FormGroup({
  //     toponimo: new FormControl('', [Validators.required]),
  //     indirizzo: new FormControl('', [Validators.required]),
  //     civico: new FormControl('', [Validators.required]),
  //     comune: new FormControl('', [Validators.required]),
  //     cap: new FormControl('', [Validators.required]),
  //     provincia: new FormControl('', [Validators.required]),
  //     indirizzoEstero: new FormControl(''),
  //     nazione: new FormControl(''),
  // });
  @Input() public options!: any;

  toponimi$: Observable<any[]> | undefined;
  comuni$: Observable<any[]> | undefined;
  province$: Observable<any[]> | undefined;

  constructor(
    private api: ApiHttpService,
    public dataService: DataService,
    private fb: FormBuilder,
    public datiAnagrafici: DatiAnagraficiComponent,
  ) {
    this.toponimi$ = this.dataService.getToponimi();
    this.comuni$ = this.dataService.getComuni();
    this.province$ = this.dataService.getProvince();
  

    // this.indirizzoForm = this.fb.group({
    //   toponimo: new FormControl('', [Validators.required]),
    //   indirizzo: new FormControl('', [Validators.required]),
    //   civico: new FormControl('', [Validators.required]),
    //   comune: new FormControl('', [Validators.required]),
    //   cap: new FormControl('', [Validators.required]),
    //   provincia: new FormControl('', [Validators.required]),
    //   indirizzoEstero: new FormControl(''),
    //   nazione: new FormControl(''),
    // })

  }

  ngOnInit(): void {

    // this.indirizzoForm?.valueChanges.subscribe(console.log);
    if (this.options == 'presso') {
      this.indirizzoForm?.addControl('presso', new FormControl(null));
    }

    // this.dataService.isCfStraniero$.subscribe(v => {
    //   console.log('indirizzo component', new Date(), v);
    //   if (v) {
    //     this.indirizzoForm.get('comune')?.reset();
    //     this.indirizzoForm.get('cap')?.reset();
    //     this.indirizzoForm.get('provincia')?.reset();
    //     this.indirizzoForm.get('provincia')?.disable();
    //   } else {
    //     this.indirizzoForm.get('provincia')?.enable();
    //   }
    // });
  };

  secondLineFn(item: any) {
    return `${item.cap} - ${item.id_provincia_id}`;
  }

  // setRequired(field: string){
  //   return this.indirizzoForm.get(field).errors?.required;
  // }

  comuneSelected(evento: any) {
    // console.log(evento);
    evento[1].map((comune: any) => {
      if (comune.id_comune == evento[0]) {
        this.indirizzoForm!.get('cap')!.patchValue(comune.cap);
        this.indirizzoForm!.get('provincia')!.patchValue(comune.id_provincia_id);
      }
    })
  }

}